<template>
  <div>
    <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="true"></b-loading>
    <br />
    <b-tabs type="is-boxed" vertical >
      <b-tab-item label="Delivery information" icon="cart">
        <div class="account">
          <h1 class="header">
            <strong>delivery information</strong>
          </h1>
          <b-field label="Home Address">
            <b-input
              v-model="address"
              type="text"
              :placeholder="address"
              class="deliveryinput"
              :disabled="disabled"
            />
          </b-field>
          <b-field label="Phone No.">
            <b-input v-model="phone" type="text" class="deliveryinput" :disabled="disabled" />
          </b-field>
          <b-field label="LGA">
            <b-input v-model="lga" type="text" class="deliveryinput" :disabled="disabled" />
          </b-field>
          <b-field label="State">
            <b-input v-model="state" type="text" class="deliveryinput" :disabled="disabled" />
          </b-field>
          <b-button type="is-info" @click="edit">EDIT INFO</b-button>
          <b-button type="is-info" @click="update" :disabled="disabled">UPDATE INFO</b-button>
        </div>
        <br>
      </b-tab-item>
      <b-tab-item label="Orders" icon="basket"></b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["isLoggedIn", "currentUser"])
  },
  data() {
    return {
      phone: "",
      state: "",
      lga: "",
      address: "",
      isLoading: false,
      disabled: true,
      isFullPage: true
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    edit() {
      this.disabled = false;
    },
    update() {
      this.disabled = true;
      this.isLoading = true;
      this.$fb.database
        .collection("accountdata")
        .where("email", "==", this.currentUser.email)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            doc.ref.update({
              address: this.address,
              LGA: this.lga,
              state: this.state,
              phone: this.phone
            });
          });
          setTimeout(
              () =>
                this.$buefy.toast.open({
                  message: `DELIVERY INFORMATION UPDATED`,
                  type: "is-success",
                  position: "is-bottom-right"
                }),
              1800
            );
          setTimeout(() => (this.isLoading = false), 1900);
          setTimeout(() => this.$router.push("/"), 2000);
        });
    },
    fetchData() {
      this.$fb.database
        .collection("accountdata")
        .where("email", "==", this.currentUser.email)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.address = doc.data().address;
            this.email = doc.data().email;
            this.phone = doc.data().phone;
            this.state = doc.data().state;
            this.lga = doc.data().LGA;
          });
        });
    },
    beforeRouteEnter(to, from, next) {
      this.$fb.database
        .collection("accountdata")
        .where("email", "==", this.currentUser.email)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            next(vm => {
              vm.address = doc.data().address;
              vm.email = doc.data().email;
              vm.phone = doc.data().phone;
              vm.state = doc.data().state;
              vm.lga = doc.data().LGA;
            });
          });
        });
    }
  }
};
</script>

<style>
.account {
  width: 50%;
  margin: auto;
}
.header {
  text-transform: uppercase;
}
</style>
